var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4168 12.2917H8.33351C7.99184 12.2917 7.70851 12.0083 7.70851 11.6667C7.70851 11.325 7.99184 11.0417 8.33351 11.0417H10.4168C12.6002 11.0417 14.3752 9.26667 14.3752 7.08333C14.3752 4.9 12.6002 3.125 10.4168 3.125H6.25018C4.06684 3.125 2.29184 4.9 2.29184 7.08333C2.29184 8 2.61684 8.89166 3.20017 9.59999C3.41684 9.86666 3.38351 10.2583 3.11684 10.4833C2.85018 10.7 2.45851 10.6667 2.23351 10.4C1.45851 9.46668 1.03351 8.29167 1.03351 7.08333C1.03351 4.20833 3.36684 1.875 6.24184 1.875H10.4085C13.2835 1.875 15.6168 4.20833 15.6168 7.08333C15.6168 9.95833 13.2918 12.2917 10.4168 12.2917Z",
    fill: "#909AB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 18.125H9.58333C6.70833 18.125 4.375 15.7917 4.375 12.9167C4.375 10.0417 6.70833 7.70837 9.58333 7.70837H11.6667C12.0083 7.70837 12.2917 7.99171 12.2917 8.33337C12.2917 8.67504 12.0083 8.95837 11.6667 8.95837H9.58333C7.4 8.95837 5.625 10.7334 5.625 12.9167C5.625 15.1 7.4 16.875 9.58333 16.875H13.75C15.9333 16.875 17.7083 15.1 17.7083 12.9167C17.7083 12 17.3833 11.1084 16.8 10.4C16.5833 10.1334 16.6167 9.74172 16.8833 9.51672C17.15 9.29172 17.5417 9.33336 17.7667 9.60003C18.5417 10.5334 18.9667 11.7084 18.9667 12.9167C18.9583 15.7917 16.625 18.125 13.75 18.125Z",
    fill: "#909AB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.799a4975be2eebef34d192d491ffa07f.svg";
export { ForwardRef as ReactComponent };